// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Megan() {
    let data=[
        {
            id: 1,
            imgSrc: '/images/MeganTMRW/MeganTMRW_1.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/MeganTMRW/MeganTMRW_2.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/MeganTMRW/MeganTMRW_3.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/MeganTMRW/MeganTMRW_4.jpg',
        },
        {
            id: 5,
            imgSrc: '/images/MeganTMRW/MeganTMRW_5.jpg',
        },
        {
            id: 6,
            imgSrc: '/images/MeganTMRW/MeganTMRW_6.jpg',
        },
        {
            id: 7,
            imgSrc: '/images/MeganTMRW/MeganTMRW_7.jpg',
        },
        {
            id: 8,
            imgSrc: '/images/MeganTMRW/MeganTMRW_8.jpg',
        },
        {
            id: 9,
            imgSrc: '/images/MeganTMRW/MeganTMRW_9.jpg',
        },
        {
            id: 10,
            imgSrc: '/images/MeganTMRW/MeganTMRW_10.jpg',
        },
        {
            id: 11,
            imgSrc: '/images/MeganTMRW/MeganTMRW_11.jpg',
        },
        {
            id: 12,
            imgSrc: '/images/MeganTMRW/MeganTMRW_12.jpg',
        },
        {
            id: 13,
            imgSrc: '/images/MeganTMRW/MeganTMRW_13.jpg',
        },
        {
            id: 14,
            imgSrc: '/images/MeganTMRW/MeganTMRW_14.jpg',
        },
        {
            id: 15,
            imgSrc: '/images/MeganTMRW/MeganTMRW_15.jpg',
        },
        {
            id: 16,
            imgSrc: '/images/MeganTMRW/MeganTMRW_16.jpg',
        },
        {
            id: 17,
            imgSrc: '/images/MeganTMRW/MeganTMRW_17.jpg',
        },
        {
            id: 18,
            imgSrc: '/images/MeganTMRW/MeganTMRW_18.jpg',
        },
        {
            id: 19,
            imgSrc: '/images/MeganTMRW/MeganTMRW_19.jpg',
        },
        {
            id: 20,
            imgSrc: '/images/MeganTMRW/MeganTMRW_20.jpg',
        },
        {
            id: 21,
            imgSrc: '/images/MeganTMRW/MeganTMRW_21.jpg',
        },
        {
            id: 22,
            imgSrc: '/images/MeganTMRW/MeganTMRW_22.jpg',
        },
        {
            id: 23,
            imgSrc: '/images/MeganTMRW/MeganTMRW_23.jpg',
        },
        {
            id: 24,
            imgSrc: '/images/MeganTMRW/MeganTMRW_24.jpg',
        },
        {
            id: 25,
            imgSrc: '/images/MeganTMRW/MeganTMRW_25.jpg',
        },
        {
            id: 26,
            imgSrc: '/images/MeganTMRW/MeganTMRW_26.jpg',
        },
        
        {
            id: 27,
            imgSrc: '/images/MeganTMRW/MeganTMRW_27.jpg',
        },
        
        {
            id: 28,
            imgSrc: '/images/MeganTMRW/MeganTMRW_28.jpg',
        },
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="Ria Megan" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="Ria Megan" style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Megan;
